const ACTIVE_DOCUMENT_ASSETS = Object.freeze([
  Object.freeze({ tag: 'link', rel: 'stylesheet', href: '/brand/v1/brand.css' }),
  Object.freeze({
    tag: 'link',
    rel: 'preload',
    as: 'image',
    type: 'image/png',
    href: '/brand/v1/beyondleads-full-lockup.png',
    fetchpriority: 'high',
  }),
  Object.freeze({ tag: 'link', rel: 'icon', href: '/brand/v1/favicon.ico' }),
  Object.freeze({ tag: 'link', rel: 'icon', type: 'image/png', sizes: '32x32', href: '/brand/v1/favicon-32.png' }),
  Object.freeze({ tag: 'link', rel: 'apple-touch-icon', sizes: '180x180', href: '/brand/v1/apple-touch-icon.png' }),
]);

const IDENTITY_ATTRIBUTE = 'data-beyondleads-document-identity';

function activeIdentityIsComplete(documentRef, assetCount) {
  const nodes = [...documentRef.head.querySelectorAll(`[${IDENTITY_ATTRIBUTE}]`)];
  if (nodes.length !== assetCount + 1) return false;
  const keys = new Set(nodes.map((node) => node.getAttribute(IDENTITY_ATTRIBUTE)));
  if (keys.size !== nodes.length || !keys.has('theme')) return false;
  return Array.from({ length: assetCount }, (_, index) => `asset-${index}`)
    .every((key) => keys.has(key));
}

export function documentIdentityForAuthType(authType) {
  if (authType !== 'supabase') {
    return Object.freeze({
      active: false,
      title: 'BeyondLeads',
      themeColor: null,
      assets: Object.freeze([]),
    });
  }
  return Object.freeze({
    active: true,
    title: 'BeyondLeads.ai — Curated Meta ads',
    themeColor: '#FAF8F4',
    assets: ACTIVE_DOCUMENT_ASSETS,
  });
}

export function storedDocumentAuthType(storage = globalThis.localStorage) {
  try {
    return JSON.parse(storage?.getItem('lp_user') || 'null')?.auth?.type || null;
  } catch {
    return null;
  }
}

export function applyDocumentIdentity(authType, documentRef = globalThis.document) {
  if (!documentRef?.head) return;
  const identity = documentIdentityForAuthType(authType);
  documentRef.title = identity.title;
  if (identity.active && activeIdentityIsComplete(documentRef, identity.assets.length)) return;
  for (const node of documentRef.head.querySelectorAll(`[${IDENTITY_ATTRIBUTE}]`)) node.remove();
  if (!identity.active) return;

  const theme = documentRef.createElement('meta');
  theme.name = 'theme-color';
  theme.content = identity.themeColor;
  theme.setAttribute(IDENTITY_ATTRIBUTE, 'theme');
  documentRef.head.append(theme);

  identity.assets.forEach((definition, index) => {
    const node = documentRef.createElement(definition.tag);
    for (const [name, value] of Object.entries(definition)) {
      if (name !== 'tag') node.setAttribute(name, value);
    }
    node.setAttribute(IDENTITY_ATTRIBUTE, `asset-${index}`);
    documentRef.head.append(node);
  });
}
